// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1466":"f8fdaf0a","2328":"0c899b64","2516":"2a9a33ac","5288":"3594cc53"}[chunkId] + ".chunk.css";
};